var map = {
	"./shipo-icon-airplane.svg": "b8f2",
	"./shipo-icon-arrow-down.svg": "18c2",
	"./shipo-icon-arrow-forward.svg": "44cfa",
	"./shipo-icon-arrow-left.svg": "a106",
	"./shipo-icon-arrow-up.svg": "d148",
	"./shipo-icon-attachment.svg": "cb50",
	"./shipo-icon-award.svg": "70ea",
	"./shipo-icon-azure.svg": "b372",
	"./shipo-icon-barge.svg": "9d90",
	"./shipo-icon-box.svg": "5ade",
	"./shipo-icon-calendar-black.svg": "2fcd",
	"./shipo-icon-calendar-eta-black.svg": "bc10",
	"./shipo-icon-calendar-expired.svg": "2aa8",
	"./shipo-icon-calendar-time.svg": "ea85",
	"./shipo-icon-check-circle.svg": "c652",
	"./shipo-icon-checkbox-false.svg": "0039",
	"./shipo-icon-checkbox-true.svg": "9886",
	"./shipo-icon-checkmark.svg": "17de",
	"./shipo-icon-close-circle.svg": "54ad",
	"./shipo-icon-close.svg": "e5fe",
	"./shipo-icon-danger.svg": "2b26",
	"./shipo-icon-delete-primary.svg": "d5d3",
	"./shipo-icon-delete.svg": "69be",
	"./shipo-icon-docking-barge.svg": "f162",
	"./shipo-icon-docking.svg": "f5d7",
	"./shipo-icon-double-arrow-down.svg": "6245",
	"./shipo-icon-double-arrow-right.svg": "fc52",
	"./shipo-icon-double-arrow-up.svg": "0693",
	"./shipo-icon-download-2.svg": "ca6f",
	"./shipo-icon-download.svg": "73f5",
	"./shipo-icon-edit-check-list.svg": "189a",
	"./shipo-icon-edit-primary.svg": "b99a",
	"./shipo-icon-edit-upload-primary.svg": "14c5",
	"./shipo-icon-edit-upload.svg": "2e16",
	"./shipo-icon-edit.svg": "aa55",
	"./shipo-icon-empty.svg": "1f3f",
	"./shipo-icon-error.svg": "8e40",
	"./shipo-icon-eye.svg": "b1d8",
	"./shipo-icon-file-download-primary.svg": "ac92",
	"./shipo-icon-file-download.svg": "f44a",
	"./shipo-icon-fleet-in-port.svg": "3e4a",
	"./shipo-icon-incoming-fleet.svg": "715a",
	"./shipo-icon-loaded.svg": "9efd",
	"./shipo-icon-log-activity.svg": "2c7f",
	"./shipo-icon-menu-board.svg": "2aca",
	"./shipo-icon-mfa-lock.svg": "faec",
	"./shipo-icon-notification.svg": "e527",
	"./shipo-icon-order-bottom-disable.svg": "c45e",
	"./shipo-icon-order-bottom.svg": "18f6",
	"./shipo-icon-order-top-disable.svg": "f7cc",
	"./shipo-icon-order-top.svg": "37f0",
	"./shipo-icon-personal-card.svg": "9cd3",
	"./shipo-icon-profile-user.svg": "6d1a",
	"./shipo-icon-radar.svg": "9ef2",
	"./shipo-icon-redo.svg": "153b",
	"./shipo-icon-return-cargo.svg": "d26d",
	"./shipo-icon-search.svg": "05ef",
	"./shipo-icon-see-green.svg": "406f",
	"./shipo-icon-see.svg": "17c4",
	"./shipo-icon-ship.svg": "8bad",
	"./shipo-icon-stopwatch-pause.svg": "fd4b",
	"./shipo-icon-trending-down.svg": "14ba",
	"./shipo-icon-trending-up.svg": "0063",
	"./shipo-icon-truck.svg": "8506",
	"./shipo-icon-upload.svg": "130e",
	"./shipo-icon-vessel.svg": "b520",
	"./shipo-icon-water.svg": "8b9d",
	"./shipo-icon-weather-cloudy.svg": "1157",
	"./shipo-icon-weather-foggy.svg": "6f3e",
	"./shipo-icon-weather-raining.svg": "eee4",
	"./shipo-icon-weather-stormy.svg": "d590",
	"./shipo-icon-weather-sunny.svg": "d194"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a008";